/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Image } from './Image'
import { ImageFromJSON, ImageFromJSONTyped, ImageToJSON } from './Image'

/**
 *
 * @export
 * @interface Member
 */
export interface Member {
  /**
   *
   * @type {string}
   * @memberof Member
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Member
   */
  position: string
  /**
   *
   * @type {Array<Image>}
   * @memberof Member
   */
  image?: Array<Image>
}

/**
 * Check if a given object implements the Member interface.
 */
export function instanceOfMember(value: object): value is Member {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('position' in value) || value['position'] === undefined) return false
  return true
}

export function MemberFromJSON(json: any): Member {
  return MemberFromJSONTyped(json, false)
}

export function MemberFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Member {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    position: json['position'],
    image:
      json['image'] == null
        ? undefined
        : (json['image'] as Array<any>).map(ImageFromJSON),
  }
}

export function MemberToJSON(value?: Member | null): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    position: value['position'],
    image:
      value['image'] == null
        ? undefined
        : (value['image'] as Array<any>).map(ImageToJSON),
  }
}
